import { useRef } from 'react';

import { isViewAccept } from './pickerProps';

// v8 reports every field edit as an "accept" (context.source === 'unknown'), so a year typed
// digit by digit reaches onAccept as 0002, 0020, 0202, 2026. Accepts that come from the
// calendar / clock / OK button (context.source === 'view') commit immediately; typed edits are
// parked and only committed once focus leaves the picker, so the caller hears from us when the
// user is done rather than on every keystroke.
export default function useCommitWhenDone({ onAccept, isCommittable }) {
    const pendingRef = useRef(null);

    const commit = (value) => {
        pendingRef.current = null;
        if (isCommittable(value)) {
            onAccept?.(value);
        }
    };

    const handleAccept = (value, context) => {
        if (isViewAccept(context)) {
            commit(value);
            return;
        }
        pendingRef.current = { value };
    };

    // React's onBlur bubbles, so this also fires when focus moves between the sections of one
    // field, between the two fields of a range, or onto the calendar button. Only commit when
    // focus actually leaves the wrapper element.
    const handleBlur = (event) => {
        const focusStillInside = event.relatedTarget && event.currentTarget.contains(event.relatedTarget);
        if (focusStillInside || !pendingRef.current) {
            return;
        }
        commit(pendingRef.current.value);
    };

    return { handleAccept, handleBlur };
}
